import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import logo from '../../styles/images/logo.svg';
import LoginRouter from './LoginRouter';
import routes from '../../common/constants/RouteConstants';
import packageJson from '../../../package.json';
import { isNonProd } from '../../envUtils';
import { VIEWER } from '../../common/constants/UserManagementConstants';

function Login() {
  const history = useHistory();
  const location = useLocation();
  const isValidSession = useSelector((state) => state.auth.isValidSession);
  const isLoading = useSelector((state) => state.auth.isLoading);
  const isShowChallenge = useSelector((state) => state.auth.isShowChallenge);
  const challengeName = useSelector((state) => state.auth.challengeName);
  const userRole = useSelector((state) => state.currentUser.user.roleName);
  const currentWorkSpace = useSelector(
    (state) => state.workSpace.currentWorkSpace
  );

  useEffect(() => {
    if (
      isValidSession &&
      currentWorkSpace &&
      Object.keys(currentWorkSpace).length !== 0
    ) {
      const pathName =
        userRole === VIEWER.roleName
          ? routes.homePage.viewer
          : routes.homePage.default;
      const { from } = location.state || {
        from: { pathname: pathName },
      };
      history.replace(from);
    }
  }, [isValidSession, currentWorkSpace, history, location.state, userRole]);

  useEffect(() => {
    if (!isLoading) {
      if (isShowChallenge) {
        if (challengeName === 'NEW_PASSWORD_REQUIRED') {
          history.push(routes.loginManagement.changePassword);
        }
        if (
          challengeName === 'SOFTWARE_TOKEN_MFA' ||
          challengeName === 'SMS_MFA'
        ) {
          history.push(routes.loginManagement.mfa);
        }
      } else if (
        currentWorkSpace &&
        (Object.keys(currentWorkSpace).length === 0 ||
          currentWorkSpace.isTemp) &&
        isValidSession
      ) {
        history.push(routes.loginManagement.selectWorkspace);
      }
    }
  }, [
    challengeName,
    history,
    isLoading,
    isShowChallenge,
    currentWorkSpace,
    isValidSession,
  ]);

  return (
    <div className="wrapper login-wrapper">
      <div className="login-promo">
        {/* <div className="graphic animated zoomIn faster" /> */}
        <div className="title animated fadeIn delay-1s">
          One platform, limitless Success
        </div>
        <div className="subtitle animated fadeIn delay-2s">
          Decrease churn. Nail operational cadence. Grow revenue. But most of
          all, set up your customers for success!
        </div>
      </div>
      <div className="login-panel">
        <p className="error-text spaced hide">
          <i className="fi flaticon-alert" /> For security reasons you have been
          signed out automatically.
        </p>

        <img src={logo} alt="Logo" className="logo" />
        {isLoading ? (
          <>
            <div className="spinner"> </div>
            <div className="filler"> </div>
          </>
        ) : (
          <LoginRouter />
        )}
        {isNonProd && <p> v{packageJson.version}</p>}
      </div>
    </div>
  );
}

export default Login;
